module.exports = __webpack_public_path__ + "assets/img/cancel.23175976.png";